import { mdiContentCopy, mdiInformationOutline, mdiPencil } from "@mdi/js"
import type { LoadListTableRow } from "../../../_shared/_logic/load-list-row-model"
import type { TableRowAction } from "@kontextwerk/web-sdk/core/layout/table"
type Props = {
  row: LoadListTableRow
  disabled?: boolean
  onEditUnits: (row: LoadListTableRow) => void
  onCopyRow: (row: LoadListTableRow) => void
  onShowDetails: (row: LoadListTableRow) => void
  readOnly?: boolean
}
export default function buildRowActions({
  row,
  disabled = false,
  onEditUnits,
  onCopyRow,
  onShowDetails,
  readOnly = false,
}: Props): TableRowAction[] {
  const actions: TableRowAction[] = [
    {
      id: "row-details",
      label: "Details zur Zeile",
      icon: mdiInformationOutline,
      tooltip: "Angaben aus der Liste und Zuordnung ansehen.",
      onClick: () => onShowDetails(row),
    },
  ]

  if (row.removed || readOnly) return actions

  if (row.propertyId) {
    actions.push({
      id: "action-0",

      label: "Wohneinheiten bearbeiten",
      onClick: () => {
        onEditUnits(row)
      },
      icon: mdiPencil,
      disabled: disabled,
      tooltip: "",
    })
  }

  actions.push({
    id: "copy-unit-row",
    label: "Weitere Einheit hinzufügen",
    icon: mdiContentCopy,
    disabled: disabled || Boolean(row.copyDisabledReason),
    tooltip: disabled
      ? "Dieser Schritt kann nicht bearbeitet werden."
      : row.copyDisabledReason ||
        "Fügt darunter eine Zeile für eine weitere Einheit dieser Liegenschaft hinzu.",
    onClick: () => onCopyRow(row),
  })

  return actions
}
